
import React from 'react';
import { Image } from '@themesberg/react-bootstrap';

import ReactLogo from "./../assets/img/kittrack-icon.png";

export default (props) => {

  const { show } = props;

  return (
    <div style={{backgroundColor:'#f5f8fb'}} className={`preloader flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
      <Image className="loader-element animate__animated animate__jackInTheBox" src={ReactLogo} height={80} />
    </div>
  );
};
